import { players } from '@/api'

const getPlayers = async (context, page) => {
  context.commit('LOADING_UPDATED', true)
  try {
    const response = await players.fetch(page, context.state.search, context.state.filter)
    context.commit('PLAYERS_UPDATED', [...context.state.players, ...response.data])
    context.commit('PAGINATION_UPDATED', page)
  } catch (e) {
    // eslint-disable-next-line
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

const searchPlayers = async (context, el) => {
  // scroll top to prevent a bug where several requests were made
  el.scroll(0, 0)
  context.commit('LOADING_UPDATED', true)
  context.commit('PLAYERS_UPDATED', [])
  context.commit('PAGINATION_UPDATED', 1)
  try {
    let search = await players.fetch(context.state.pagination.currentPage, context.state.search, context.state.filter)
    context.commit('PLAYERS_UPDATED', search.data)
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}
export default {
  getPlayers,
  searchPlayers
}



// WEBPACK FOOTER //
// ./src/store/modules/players/actions.js